import React, { useState, useCallback, useRef } from 'react';
import api from '../services/api';
import PixiWheelCanvas from '../pixi/PixiWheelCanvas';
import SpinResultModal from './SpinResultModal';
import './LuckyWheelGame.css';

const PUBLIC = process.env.PUBLIC_URL || '';

/**
 * 輪盤遊戲頁面元件
 * 管理抽獎流程：按鈕 -> API -> 動畫 -> 結果
 */
function LuckyWheelGame({ config, playerInfo, onSpinComplete }) {
  const [spinning, setSpinning] = useState(false);
  const [result, setResult] = useState(null);
  const [showResult, setShowResult] = useState(false);
  const [error, setError] = useState('');
  const audioCtxRef = useRef(null);

  const handleSpin = useCallback(async () => {
    if (spinning) return;

    // 在使用者點擊中解鎖並保存 AudioContext（iPhone Safari 必須在 user gesture 中觸發）
    if (!audioCtxRef.current) {
      try {
        const ctx = new (window.AudioContext || window.webkitAudioContext)();
        const buf = ctx.createBuffer(1, 1, 22050);
        const src = ctx.createBufferSource();
        src.buffer = buf;
        src.connect(ctx.destination);
        src.start(0);
        audioCtxRef.current = ctx;
      } catch (e) { /* ignore */ }
    } else if (audioCtxRef.current.state === 'suspended') {
      audioCtxRef.current.resume().catch(() => {});
    }

    setSpinning(true);
    setError('');
    setResult(null);

    try {
      const spinResult = await api.spin(config.id);
      setResult(spinResult);
      // PixiWheelCanvas 會根據 result 播放動畫
    } catch (err) {
      setError(err.message || '抽獎失敗，請稍後再試');
      setSpinning(false);
    }
  }, [spinning, config]);

  const handleAnimationComplete = useCallback(() => {
    setSpinning(false);
    setShowResult(true);
  }, []);

  const handleCloseResult = useCallback(() => {
    setShowResult(false);
    if (onSpinComplete) {
      onSpinComplete();
    }
  }, [onSpinComplete]);

  const prizes = config?.prizes || [];

  return (
    <div className="wheel-game-container">
      {/* 輪盤主體 */}
      <div className="wheel-wrapper">
        <div className={`wheel-glow ${spinning ? 'active' : ''}`} />
        <PixiWheelCanvas
          prizes={prizes}
          spinResult={result}
          onAnimationComplete={handleAnimationComplete}
        />
      </div>

      {/* 抽獎按鈕 */}
      <div className="spin-btn-area">
        {error && (
          <div className="spin-error fade-in">{error}</div>
        )}
        <button
          className={`spin-button ${spinning ? 'spinning' : ''}`}
          onClick={handleSpin}
          disabled={spinning}
        >
          <span className="spin-button-inner">
            {spinning ? (
              <>
                <span className="spin-dots">
                  <span /><span /><span />
                </span>
                抽獎中
              </>
            ) : (
              '開始抽獎'
            )}
          </span>
        </button>
      </div>

      {/* 結果彈窗 */}
      {showResult && result && (
        <SpinResultModal
          result={result}
          playerInfo={playerInfo}
          onClose={handleCloseResult}
          audioCtx={audioCtxRef.current}
        />
      )}
    </div>
  );
}

export default LuckyWheelGame;
